import React from 'react';
const MALE = [{
  category: '- 58 Kg / 128 lbs',
  size: '#3',
  level: '30'
}, {
  category: '+ 58/-68 Kg / 128/150 lbs',
  size: '#3',
  level: '32'
}, {
  category: '+68/-80 Kg / 150/176 lbs',
  size: '#4',
  level: '34'
}, {
  category: '+ 80 Kg / 176 lbs',
  size: '#5',
  level: '36'
}];
const FEMALE = [{
  category: '- 49 Kg / 108 lbs',
  size: '#2',
  level: '25'
}, {
  category: '+ 49/-57 Kg / 108/126 lbs',
  size: '#2',
  level: '27'
}, {
  category: '+ 57/-67 Kg / -126/148 lbs',
  size: '#3',
  level: '30'
}, {
  category: '+ 67 Kg / 148 lbs',
  size: '#3',
  level: '32'
}];
type Row = {
  category: string;
  size: string;
  level: string;
};
/**
 * W.T.F. Olympic Category tables (male + female).
 * Owns its own data and table markup.
 */
export function OlympicCategory() {
  return <div className="space-y-12" data-id="element-904">
      <Table title="Senior MALE (남자)" headerBg="bg-blue-600" rows={MALE} data-id="element-905" />
      <Table title="Senior FEMALE (여자)" headerBg="bg-pink-600" rows={FEMALE} data-id="element-906" />
    </div>;
}
function Table({
  title,
  headerBg,
  rows
}: {
  title: string;
  headerBg: string;
  rows: Row[];
}) {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-907">
      <div className={`${headerBg} px-6 py-4`} data-id="element-908">
        <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-909">
          {title}
        </h2>
      </div>
      <div data-id="element-910">
        <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-911">
          <tbody data-id="element-912">
            <tr className="border-b border-gray-200 bg-gray-50" data-id="element-913">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-914">
                Category
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 text-gray-600 font-medium" data-id="element-915">
                  {item.category}
                </td>)}
            </tr>
            <tr className="border-b border-gray-200" data-id="element-916">
              <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-917">
                Size EBP
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-918">
                  {item.size}
                </td>)}
            </tr>
            <tr className="bg-gray-50" data-id="element-919">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-920">
                LEVEL
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-921">
                  {item.level}
                </td>)}
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}